import makeRoot from "./root";
import makeContained from "./contained";
import makeOutlined from "./outlined";
import makeButtonText from "./text";

export default function button(theme) {
  const root = makeRoot(theme);
  const contained = makeContained(theme);
  const outlined = makeOutlined(theme);
  const buttonText = makeButtonText(theme);

  return {
    defaultProps: {
      disableRipple: false,
    },
    styleOverrides: {
      root: { ...root },
      contained: { ...contained.base },
      containedSizeSmall: { ...contained.small },
      containedSizeLarge: { ...contained.large },
      containedPrimary: { ...contained.primary },
      containedSecondary: { ...contained.secondary },
      outlined: { ...outlined.base },
      outlinedSizeSmall: { ...outlined.small },
      outlinedSizeLarge: { ...outlined.large },
      outlinedPrimary: { ...outlined.primary },
      outlinedSecondary: { ...outlined.secondary },
      text: { ...buttonText.base },
      textSizeSmall: { ...buttonText.small },
      textSizeLarge: { ...buttonText.large },
      textPrimary: { ...buttonText.primary },
      textSecondary: { ...buttonText.secondary },
    },
  };
}
